import { useEffect, useCallback } from "react";
import { X, ChevronLeft, ChevronRight } from "lucide-react";

export default function Lightbox({ images, index, onClose, onPrev, onNext }) {
  const handleKey = useCallback((e) => {
    if (e.key === "Escape") onClose();
    else if (e.key === "ArrowLeft") onPrev();
    else if (e.key === "ArrowRight") onNext();
  }, [onClose, onPrev, onNext]);

  useEffect(() => {
    document.addEventListener("keydown", handleKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", handleKey);
      document.body.style.overflow = prev;
    };
  }, [handleKey]);

  if (!images?.length) return null;
  const src = images[index];
  const total = images.length;

  return (
    <div className="fixed inset-0 bg-black/95 z-[100] flex items-center justify-center animate-fadein" data-testid="lightbox" onClick={onClose}>
      <button onClick={(e) => { e.stopPropagation(); onClose(); }}
        className="absolute top-4 right-4 w-11 h-11 flex items-center justify-center text-white hover:text-[#D71920] bg-black/40 hover:bg-black/70 transition"
        aria-label="Close" data-testid="lightbox-close"><X className="w-6 h-6" /></button>

      <div className="absolute top-4 left-4 text-white/70 text-xs uppercase tracking-widest font-bold font-mono-tech" data-testid="lightbox-counter">
        {index + 1} / {total}
      </div>

      {total > 1 && (
        <>
          <button onClick={(e) => { e.stopPropagation(); onPrev(); }}
            className="absolute left-4 md:left-8 top-1/2 -translate-y-1/2 w-12 h-12 flex items-center justify-center text-white hover:text-[#D71920] bg-black/40 hover:bg-black/70 transition"
            aria-label="Previous" data-testid="lightbox-prev"><ChevronLeft className="w-7 h-7" /></button>
          <button onClick={(e) => { e.stopPropagation(); onNext(); }}
            className="absolute right-4 md:right-8 top-1/2 -translate-y-1/2 w-12 h-12 flex items-center justify-center text-white hover:text-[#D71920] bg-black/40 hover:bg-black/70 transition"
            aria-label="Next" data-testid="lightbox-next"><ChevronRight className="w-7 h-7" /></button>
        </>
      )}

      <img src={src} alt="" onClick={(e) => e.stopPropagation()} className="max-w-[92vw] max-h-[88vh] object-contain" data-testid="lightbox-image" />
    </div>
  );
}
